import { useState } from 'react';
import { ConditionalRender } from 'components/layout/ConditionalRender';
import { NewIssueMain } from './components/NewIssueMain/components/NewIssueMain';
import { NewIssueSuccess } from './components/NewIssueSuccess/NewIssueSuccess';

export const NewIssue = () => {

    const [createdSuccessfully, setCreatedSuccessfully] = useState<boolean>(false);

    const showSuccess = () => {
        setCreatedSuccessfully(true);
    }

    const hideSuccess = () => {
        setCreatedSuccessfully(false);
    }

    return (
        <>
            <ConditionalRender condition={createdSuccessfully} >
                <NewIssueSuccess onCreateAnother={ hideSuccess } />
            </ConditionalRender>
            <ConditionalRender condition={!createdSuccessfully} >
                <NewIssueMain onComplete={showSuccess} />
            </ConditionalRender>
        </>
    );
};